<!-- components/basket/BasketNumberKitchenAppliances.vue -->
<script setup lang="ts">
// 1. Принимаем из родителя prop `cutlery`
const props = defineProps<{ cutlery: number }>();

// 2. Эмитим событие обновления
const emit = defineEmits<{
  (e: 'update:cutlery', value: number): void
}>();

// 3. Обработчик, когда компонент UiBaseCounter отдаёт новое значение
//    — просто прокидываем наверх
const onCountChange = (val) => {
  const safe = Number(val);
  emit('update:cutlery', Number.isNaN(safe) || safe < 0 ? 0 : safe);
};
</script>

<template>
  <section class="grid grid-cols-[20px_1fr_auto] gap-5 items-center p-5">
    <!-- Иконка -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 3v12h-5c-.023-3.681.184-7.406 5-12m0 12v6h-1v-3M8 4v17M5 4v3a3 3 0 1 0 6 0V4"
      />
    </svg>

    <p>Приборы</p>

    <!-- Выставляем props.cutlery и слушаем event count -->
    <UiBaseCounter
      size="sm"
      class="w-36"
      :min-v="0"
      :count-v="props.cutlery"
      @count="onCountChange"
    />
  </section>
</template>
